'use strict';

/**
 * @generated SignedSource<<b9ebb554de6d234111979458a7fb083e>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "concreteType": "AuthenticatedInfoResponse",
            "kind": "LinkedField",
            "name": "authenticatedInfo",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasSparkId",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isGuest",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isLoggedIn",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProfileInfo",
                    "kind": "LinkedField",
                    "name": "profile",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "lastName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "firstName",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "loginOption",
                            "storageKey": null
                        },
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "csrTNumber",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "metadata": null,
            "name": "GlobalUserProviderAuthenticatedInfoQuery",
            "selections": (v0 /*: any*/),
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "GlobalUserProviderAuthenticatedInfoQuery",
            "selections": (v0 /*: any*/)
        },
        "params": {
            "cacheID": "b374c688a54bad627a614921a5c5899f",
            "id": null,
            "metadata": {},
            "name": "GlobalUserProviderAuthenticatedInfoQuery",
            "operationKind": "query",
            "text": "query GlobalUserProviderAuthenticatedInfoQuery {\n  authenticatedInfo {\n    hasSparkId\n    isGuest\n    isLoggedIn\n    profile {\n      lastName\n      firstName\n      loginOption\n      csrTNumber\n    }\n  }\n}\n"
        }
    };
})();
node.hash = "1c0f1a8d2f94626836ecdbbca5506575";

module.exports = node;
